var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5584 4.35573C16.2167 4.2224 14.875 4.1224 13.525 4.0474V4.03906L13.3417 2.95573C13.2167 2.18906 13.0334 1.03906 11.0834 1.03906H8.90005C6.95838 1.03906 6.77505 2.13906 6.64172 2.9474L6.46672 4.01406C5.69172 4.06406 4.91672 4.11406 4.14172 4.18906L2.44172 4.35573C2.09172 4.38906 1.84172 4.6974 1.87505 5.03906C1.90838 5.38073 2.20838 5.63073 2.55838 5.5974L4.25838 5.43073C8.62505 4.9974 13.0251 5.16406 17.4417 5.60573C17.4667 5.60573 17.4834 5.60573 17.5084 5.60573C17.8251 5.60573 18.1 5.36406 18.1334 5.03906C18.1584 4.6974 17.9084 4.38906 17.5584 4.35573Z",
    fill: "#A461D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3991,
    d: "M16.0254 6.78594C15.8254 6.5776 15.5504 6.46094 15.2671 6.46094H4.73378C4.45044 6.46094 4.16711 6.5776 3.97544 6.78594C3.78378 6.99427 3.67544 7.2776 3.69211 7.56927L4.20878 16.1193C4.30044 17.3859 4.41711 18.9693 7.32544 18.9693H12.6754C15.5838 18.9693 15.7004 17.3943 15.7921 16.1193L16.3088 7.5776C16.3254 7.2776 16.2171 6.99427 16.0254 6.78594Z",
    fill: "#A461D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9834 14.1641C7.9834 13.8189 8.26322 13.5391 8.6084 13.5391H11.3834C11.7286 13.5391 12.0084 13.8189 12.0084 14.1641C12.0084 14.5092 11.7286 14.7891 11.3834 14.7891H8.6084C8.26322 14.7891 7.9834 14.5092 7.9834 14.1641Z",
    fill: "#A461D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29199 10.8359C7.29199 10.4908 7.57181 10.2109 7.91699 10.2109H12.0837C12.4288 10.2109 12.7087 10.4908 12.7087 10.8359C12.7087 11.1811 12.4288 11.4609 12.0837 11.4609H7.91699C7.57181 11.4609 7.29199 11.1811 7.29199 10.8359Z",
    fill: "#A461D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.4cb8e58cac953f27b1e978378ebb4387.svg";
export { ForwardRef as ReactComponent };